// this is like DPI. 3 = 300 DPI
const SCALE = 3;

export const IMAGE_HEIGHT = 264 * SCALE;
export const IMAGE_WIDTH = 415 * SCALE;
export const TEXT_HEIGHT = 30 * SCALE;
export const TEXT_LINEHEIGHT = TEXT_HEIGHT * 1.75;
export const TEXT_PADDING = 4 * SCALE;
